import React, { useState } from 'react';
import Card from "../../Components/Resources/Card.jsx";
import PageHeader from '../../Components/Layout/PageHeader/PageHeader.js';
import SectionHeader from '../../Components/Layout/SectionHeader/SectionHeader.jsx';

export default function Resources() {
  const [tabs, setTabs] = useState([{ label: "All Resources", isActive: true }]);
  const [cards, setCards] = useState([
    { id: 1, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 2, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 3, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 4, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 5, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 6, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 7, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" },
    { id: 8, name: "File Name will be presented here.pdf", size: "10.1", date: "6/20/24" }
  ]);

  const handleTabClick = (index) => {
    setTabs((prevTabs) =>
      prevTabs.map((tab, i) => ({
        ...tab,
        isActive: i === index
      }))
    );
  };

  const handleDownload = (id) => {
    // Add your download logic here
  };

  const handleDelete = (id) => {
    setCards((prevCards) => prevCards.filter((card) => card.id !== id));
  };

  return (
    <div className='resources'>
      <PageHeader currentPage={"Resources"} />
      <SectionHeader tabs={tabs} handleTabClick={handleTabClick} />
      <div className='resources-content'>
        {cards.map((card) => (
          <Card key={card.id} id={card.id} fileName={card.name} fileSize={card.size} date={card.date} onDownload={() => handleDownload(card.id)} onDelete={() => handleDelete(card.id)} />
        ))}
      </div>
    </div>
  );
}
